import SettingsPage from "./SettingsPage";

export default function Notifications() {
    return <SettingsPage title="Notifications" />;
}
